







































import { Vue } from 'vue-property-decorator';

export default Vue.extend({
  name: 'LogIn',
  data() {
    return {
      email: '',
      password: '',
      alert: false
    };
  },
  methods: {
    logIn() {
      this.$store.dispatch('logIn', { email: this.email, password: this.password });
    }
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit('error', null);
      }
    }
  }
});
